// Layouts
import MainLayout from 'Layouts/Main/Main';
import { lazy } from 'react';

const PrescriptionList = lazy(() => import('Containers/Prescription/PrescriptionList/PrescriptionList'));

const routes = [
  {
    path: '/prescriptions',
    exact: true,
    ContentComponent: PrescriptionList,
    Layout: MainLayout,
    name: 'Prescription',
  },
];

export default routes;
